import { html } from 'lit';
import { property, queryAssignedElements } from 'lit/decorators.js';
import { AttributeValueValidator } from '../../lib/attribute-value-validator/attribute-value-validator.js';
import { DeepSlotChangeController } from '../../lib/deep-slot-change-controller/deep-slot-change-controller.js';
import { LinkSlottedFormElementsController } from '../../lib/link-slotted-form-elements/link-slotted-form-elements.js';

var __defProp = Object.defineProperty;
var __decorateClass = (decorators, target, key, kind) => {
  var result = void 0 ;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (decorator(target, key, result) ) || result;
  if (result) __defProp(target, key, result);
  return result;
};
const CrntCheckableFormControlMixin = (superClass, mixinOptions) => {
  class CrntCheckableFormControl extends superClass {
    constructor() {
      super(...arguments);
      this.bordered = false;
      this.disableAutoLink = false;
      this.interactionState = "default";
      this._controlTypeValidator = new AttributeValueValidator({
        attributeKey: "type",
        host: this,
        validValues: [mixinOptions.inputType]
      });
      this._linkSlottedFormElementsController = new LinkSlottedFormElementsController({
        enabled: false,
        host: this,
        selectors: {
          help: '[slot="help"]',
          input: ":not([slot]):is(input,textarea)",
          label: 'label[slot="label"]'
        }
      });
      this._deepSlotChangeController = new DeepSlotChangeController({
        callback: (mutations) => this._linkSlottedFormElementsController.deepSlotChangeCallback(mutations),
        host: this
      });
    }
    static {
      this.styles = [superClass.styles ?? []];
    }
    static {
      this.tagName = "crnt-checkable-form-control";
    }
    connectedCallback() {
      super.connectedCallback();
      this._linkSlottedFormElementsController.enabled = !this.disableAutoLink;
    }
    render() {
      return html`
				<div part="container">
					<div part="icon-container icon-container--checked">${this._renderCheckedBox()}</div>
					<div part="icon-container icon-container--unchecked">${this._renderUncheckedBox()}</div>
					<div part="control">
						<slot @slotchange=${this._handleSlotChange}></slot>
					</div>
					<div part="label">
						<slot @slotchange=${this._handleSlotChange} name="label"></slot>
					</div>
					<div part="help">
						<slot @slotchange=${this._handleSlotChange} name="help"></slot>
					</div>
				</div>
			`;
    }
    firstUpdated(_changedProperties) {
      super.firstUpdated(_changedProperties);
      this._controls?.forEach((control) => {
        this._controlTypeValidator.validate(control.type);
      });
    }
    willUpdate(_changedProperties) {
      super.willUpdate(_changedProperties);
      if (_changedProperties.has("disableAutoLink")) {
        this._linkSlottedFormElementsController.willUpdate();
        this._linkSlottedFormElementsController.enabled = !this.disableAutoLink;
      }
    }
    _handleSlotChange() {
      this._linkSlottedFormElementsController.handleSlotChange();
    }
    _renderCheckedBox() {
      console.error("_renderCheckedBox not implemented, return empty string");
      return html``;
    }
    _renderUncheckedBox() {
      console.error("_renderUncheckedBox not implemented, return empty string");
      return html``;
    }
  }
  __decorateClass([
    property({ reflect: true, type: Boolean })
  ], CrntCheckableFormControl.prototype, "bordered");
  __decorateClass([
    property({ attribute: "disable-auto-link", reflect: true, type: Boolean })
  ], CrntCheckableFormControl.prototype, "disableAutoLink");
  __decorateClass([
    property({ attribute: "interaction-state" })
  ], CrntCheckableFormControl.prototype, "interactionState");
  __decorateClass([
    queryAssignedElements({ selector: "input" })
  ], CrntCheckableFormControl.prototype, "_controls");
  return CrntCheckableFormControl;
};

export { CrntCheckableFormControlMixin };
